import { Box, Flex, FlexProps } from '@chakra-ui/react';
import { AlertIcon } from 'ui-components';
import { convertPxToRems } from '~/utils-ts';

import { IIconProps } from '../Icon';

interface Props extends FlexProps {
  iconProps?: IIconProps;
  trackId?: string;
}

export const FallbackImage = ({ iconProps, trackId, ...props }: Props) => (
  <Flex
    direction="column"
    justifyContent="center"
    alignItems="center"
    backgroundColor="primary.50"
    borderRadius={convertPxToRems(5)}
    {...props}
    fontSize={12}
    textAlign={'center'}
  >
    <AlertIcon
      boxSize={6}
      color="primary.600"
      track-id={trackId}
      {...iconProps}
    />
    <Box width={convertPxToRems(84)} paddingTop={1}>
      Preview is not available
    </Box>
  </Flex>
);
